<template>
   <div>
       <div class="mainBox">

           <div class="mainCenter">
               <div id="introduceRoom" class="navRoom"></div>
               <div class="introduce">
                   <h3 v-if="menuData.length>0">{{menuData[0].itemName}}</h3>

                   <div class="introduce-text"  v-html="productData.content">
                   </div>


                   <div class="itemBox"  v-for="(item,index) in productList" :key="item.articleId">
                       <!--:class="{'icon-falv2': index === 0, 'icon-falvfagui20x20': index === 1, 'icon-falv': index=== 2 }"-->
                       <img  :class="index %2 == 0  ? 'floatL' : 'floatR'"  :src="item.thumb" alt="">
                       <div class="itemContent" :style="{float: index %2 == 0 ? 'right' : 'left'}">
                           <div  :class="index %2 == 0  ? 'middleBox' : 'middleBox mr32'" v-if="particleContent[index]" >
                               <h3 >{{item.filterTagTitle}}</h3>
                               <p class="h16"></p>
                               <p  v-html="particleContent[index].content"> </p>
                               <Button  data-toggle="modal" data-target="#btnDetail" class="btnDetailStyle" @mouseenter="enter(index)" @mouseleave="leave(index)">了解详情 <i class="iconfont icon-youjiantou " ></i></Button>
                           </div>
                       </div>
                   </div>

                   <!--<div class="itemBox">-->
                       <!--<img class="floatR"  src="../../public/static/images/img2.png" alt="">-->
                       <!--<div class="itemContent">-->
                           <!--<div class="middleBox mr32"  >-->
                               <!--<h3>大屏设计器</h3>-->
                               <!--<p class="h16"></p>-->
                               <!--<p>-->
                                   <!--支持对数据、统计图等进行钻取切片等操作，直观地展现个性视角，全方位支撑领导决策。-->
                               <!--</p>-->

                               <!--<Button data-toggle="modal" data-target="#btnDetail">了解详情 <i class="iconfont icon-youjiantou " ></i></Button>-->
                           <!--</div>-->
                       <!--</div>-->
                   <!--</div>-->



               </div>
           </div>


           <div id="advantageRoom" class="advantage">
               <div class="mainCenter">
                   <h3>产品优势</h3>

                   <div class="advantageContent" style="text-align: left" v-if="advantageList" :style="{textAlign: advantageList.length>=3 ? 'left' :'center'}">
                       <!--<div class="advantageCard" >-->
                           <!--<div class="advantageIcon">-->
                               <!--<svg class="iconfont  " >-->
                                   <!--<use xlink:href="#icon-zhantingzhinengzhongkongxitong"  />-->
                               <!--</svg>-->
                           <!--</div>-->

                           <!--<div class="advantageText">-->
                               <!--<p class="textTitle">数据全生命周期管理</p>-->
                               <!--<p class="textMain">从数据采集，到数据的ETL处理，再到数据的存储和管理，为前端业务的自由探索和分析提供了强大的数据支持。</p>-->
                           <!--</div>-->

                       <!--</div>-->
                       <div class="advantageCard" v-for="(item,index) in advantageList" :key="item.articleId" >
                           <div class="advantageIcon">
                                   <img class="iconfont "  :src="item.thumb"  />
                           </div>
                           <div class="advantageText">
                               <p class="textTitle">{{item.filterTagTitle}}</p>
                               <p class="textMain">{{item.content | htmlfilter}}</p>
                           </div>
                       </div>




                   </div>



                   <!--<div class="advantageContent" style="margin-top: 10px;">-->
                       <!--<div class="advantageCard">-->
                           <!--<div class="advantageIcon">-->
                               <!--<svg class="iconfont  " >-->
                                   <!--<use xlink:href="#icon-keshihuazhinengyibiaoban"  />-->
                               <!--</svg>-->
                           <!--</div>-->

                           <!--<div class="advantageText">-->
                               <!--<p class="textTitle">可视化智能仪表板</p>-->
                               <!--<p class="textMain">提供丰富的数据视图，支持钻取切片等多种数据操作，有利于进行更深入的分析。</p>-->
                           <!--</div>-->

                       <!--</div>-->

                       <!--<div class="advantageCard">-->
                           <!--<div class="advantageIcon">-->
                               <!--<svg class="iconfont  " >-->
                                   <!--<use xlink:href="#icon-anlifuzhufenxi"  />-->
                               <!--</svg>-->
                           <!--</div>-->

                           <!--<div class="advantageText">-->
                               <!--<p class="textTitle">案例辅助分析</p>-->
                               <!--<p class="textMain">针对高校提供多种解决方案，利用数理统计、数据挖掘技术对数据仓库里的数据进行多角度、多维度的挖掘和分析，并提供诊断与改进建议。</p>-->
                           <!--</div>-->

                       <!--</div>-->

                       <!--<div class="advantageCard">-->
                           <!--<div class="advantageIcon">-->
                               <!--<svg class="iconfont  " >-->
                                   <!--<use xlink:href="#icon-pingtaitongyiguankong"  />-->
                               <!--</svg>-->
                           <!--</div>-->

                           <!--<div class="advantageText">-->
                               <!--<p class="textTitle">平台统一管控</p>-->
                               <!--<p class="textMain">实现用户、权限等的集中管理，采用“一个平台”的信息化管理方式，让用户在有序的管控下自由分析。</p>-->
                           <!--</div>-->

                       <!--</div>-->

                   <!--</div>-->

               </div>

           </div>


           <div id="updateRoom" class="update">
               <div class="mainCenter">
                   <h3>版本更新</h3>
                   <div class="bgWhite">
                       <div class="updateLeft">

                           <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                               <!-- Indicators -->
                               <ol class="carousel-indicators">
                                   <li  v-for="(item,index) in slideData"
                                        data-target="#carousel-example-generic"
                                        :data-slide-to="index"
                                        :key="index"
                                        :class="index==0 ? 'active' : '' "></li>
                                   <!--<li data-target="#carousel-example-generic" data-slide-to="1"></li>-->
                                   <!--<li data-target="#carousel-example-generic" data-slide-to="2"></li>-->
                               </ol>

                               <!-- Wrapper for slides -->
                               <div class="carousel-inner" role="listbox">
                                   <!--class="item active"-->
                                   <div   v-for="(item,index) in slideData"  :key="item.pictureId" :class="index==0 ? 'item active' : 'item'">
                                       <img :src="item.url" alt="..." style="width:560px;height:318px;">
                                       <div class="carousel-caption">
                                       </div>
                                   </div>
                                   <!--<div class="item">-->
                                       <!--<img src="../../public/static/images/img2.png" alt="...">-->
                                       <!--<div class="carousel-caption">-->
                                       <!--</div>-->
                                   <!--</div>-->
                                   <!--<div class="item">-->
                                       <!--<img src="../../public/static/images/img3.png" alt="...">-->
                                       <!--<div class="carousel-caption">-->
                                       <!--</div>-->
                                   <!--</div>-->

                               </div>

                               <!-- Controls -->
                               <!--<a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">-->
                               <!--<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>-->
                               <!--<span class="sr-only">Previous</span>-->
                               <!--</a>-->
                               <!--<a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">-->
                               <!--<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>-->
                               <!--<span class="sr-only">Next</span>-->
                               <!--</a>-->
                           </div>

                       </div>


                       <div class="updateRight">
                           <div>
                              <h3 class="urTitle" >{{updateData.title | htmlfilter}}&nbsp;<span class="urTitleNum" >{{updateData.articleAbstract | htmlfilter}}</span></h3>
                           </div>
                           <div class="updateRight_ul">
                               <div v-html="updateData.content" ref="updateHeight">

                               </div>
                               <!--<li><span>更新内容1全方位整合碎片化数据；</span></li>-->

                           </div>
                           <p class="ellipsisBox" v-if="updateRightUlHeight > 180" style="float: left;padding-left: 16px">......</p>


                         <div>
                             <div class="updateRight_btnBox">
                                 <Button data-toggle="modal" data-target="#deepknow">查看往期</Button>
                                 <Button data-toggle="modal" data-target="#btnDetail">深入了解</Button>
                             </div>
                         </div>

                       </div>


                   </div>
               </div>
           </div>


           <div id="contactRoom" class="contactUs">
               <div class="mainCenter ">
                   <h3>联系我们</h3>

                   <div class="contactUs_form">

                       <form class="form-inline" v-on:submit.prevent="sub">
                           <div class="formRadioBox" >
                               <label class="radio-inline" style="margin-right: 16px;" >
                                   <input type="radio" name="inlineRadioOptions" id="business" value='1'  v-model="radioValue" required="true">商务咨询
                               </label>
                               <label class="radio-inline">
                                   <input type="radio" name="inlineRadioOptions" id="suggest" value='2' v-model="radioValue"   required="true">意见反馈
                               </label>
                           </div>


                           <div class="formBox">
                               <div class="form-group form_item_box mr32">
                                   <label for="name"><span class="star">*&nbsp;</span>姓名</label>
                                   <input type="text" class="form-control" id="name" placeholder="请输入您的姓名" style="text-align: left"  v-model="name"  required="true" >
                               </div>
                               <div class="form-group form_item_box mr32">
                                   <label for="email"><span class="star">*&nbsp;</span>电子邮箱</label>
                                   <input class="form-control" id="email" placeholder="请输入您的电子邮箱" style="text-align: left"
                                          required="true"
                                          pattern="^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$"
                                          oninvalid = "setCustomValidity('请输入正确的电子邮箱')"
                                          oninput="setCustomValidity('')"
                                          v-model="email">
                               </div>
                               <div class="form-group form_item_box">
                                   <label for="phone"><span class="star">*&nbsp;</span>手机号码</label>
                                   <input  class="form-control" id="phone" placeholder="请输入您的手机号码"  style="text-align: left"
                                           required="true"
                                           pattern="^1[3|4|5|6|7|8][0-9]{9}$"
                                           oninvalid = "setCustomValidity('请输入正确的手机号')"
                                           oninput="setCustomValidity('')"
                                           v-model="phone"
                                           >
                               </div>
                           </div>

                           <div class="form-group form_item_box form_item_box_other" >
                               <label for="other">备注信息</label>
                               <input type="text" class="form-control" id="other" placeholder="请输入备注信息" style="margin-left:16px; width: 890px;text-align: left" v-model="message" >
                           </div>

                           <div style="margin-top: 32px;">
                               <button  class="btn btn-default form_submit_btn" style="border: none">点击提交</button>
                           </div>

                       </form>


                   </div>

               </div>
           </div>
       </div>

       <div id="btnDetail"  class="modal fade btnDetail" tabindex="-1" role="dialog" aria-labelledby="gridSystemModalLabel">
           <div class="modal-dialog" role="document">
               <div class="modal-content ">
                   <div class="modal-header" style="position: relative;padding:8px 15px 4px 15px;">
                       <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                           <span aria-hidden="true" style="font-size: 20px;">&times;</span>
                       </button>
                   </div>

                   <div class="modal-body">
                       <h4 style="margin-bottom: 12px;">进一步了解EI </h4>
                       <p>如需深入了解ZEMCHO EI ，请填写以下信息，工作人员将与您沟通，协助您快速建立数据解决方案</p>

                       <form class="form-inline" v-on:submit.prevent="knowsub">

                           <input  type="text" class="form-control mr32" id="knowName" placeholder="姓名" v-model="knowname" required="true">
                           <input type="text" class="form-control" id="knowJob" placeholder="职位" v-model="knowposition">
                           <input  type="text" class="form-control mr32" id="knowPhone" placeholder="手机号码"
                                   v-model="knowphone"
                                   pattern="^1[3|4|5|6|7|8][0-9]{9}$"
                                   oninvalid = "setCustomValidity('请输入正确的手机号码')"
                                   oninput="setCustomValidity('')"
                           >
                           <input   class="form-control" id="knowEmail" placeholder="邮箱"
                                     v-model="knowemail" required="true"
                                    pattern="^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$"
                                    oninvalid = "setCustomValidity('请输入正确的邮箱')"
                                    oninput="setCustomValidity('')"
                           >

                           <textarea class="form-control" rows="3"  v-model="knowmes" placeholder="您希望通过EI解决什么问题或需求？"></textarea>

                           <button type="submit" class="btn btn-default knowBtn" >提交信息，我们会尽快联系您</button>
                       </form>


                   </div>

               </div><!-- /.modal-content -->
           </div><!-- /.modal-dialog -->
       </div><!-- /.modal -->

       <DeepModal v-if="menuData[2]"  v-bind:updateChildren="menuData[2].children" ></DeepModal>
   </div>


</template>

<script>

import DeepModal from '@/components/deepModal.vue'

    export default {
        name: "Index",
        data(){
            return{
                slideData: [],  //轮播图
                menuData:[],
                productData:{},
                productUid:'',
                productList:[],  //产品内容详情列表
                particleContent:[],


                updateData:{}, //版本更新
                updateUid:'',
                updateList:[],

                updateChildren:[],

                advantageUid:'',
                advantageList:[],
                advantageData:[],

                catalogueData_0: {},
                catalogueData_1: {},
                catalogueData_2: {},
                catalogueData_3: {},
                catalogueData_4: {},


                //form
                name:'',
                radioValue:"1",
                phone:'',
                email:'',
                message:'',

                knowname:'',
                knowphone:'',
                knowemail:'',
                knowposition:'',
                knowmes:'',

                updateRightUlHeight:0,
            }

        },
        created(){
            //导航的uid-> 找目录的对应目录id -> 文章
            this.$GetMenuData().then(() => {
                const { items=[] } = this.$store.state.menuData
                this.menuData = items;
                this.productUid = items[0].toUid;
                this.updateUid = items[2].toUid;
                this.updateChildren = items[2].children;

                this.advantageUid = items[1].toUid;
            }).then(()=>{

                //产品介绍 只是第一篇文章 ！！
                this.$GetArticleData({locationId:1}).then(() => {
                    this.productData = this.$store.state.articleData;
                });
                //产品介绍下的目录内容
                this.$GetCatalogueData({ catalogueId:this.productUid,})
                    .then(() => {
                        this.catalogueData = this.$store.state.catalogueData;
                        this.productList = this.$store.state.catalogueData.articles.list;

                    }).then(()=>{
                        this.productList.map((item,i)=>{
                            // console.log(i,item);
                            //获取具体文章
                            this.$GetArticleData({ articleId: item.articleId}).then(() => {
                                this.particleContent.push(this.$store.state.articleData);
                                // this.productList[i].content= this.$store.state.articleData.content;
                              //  console.log(22,this.particleContent);
                            });
                        })
                })

                //版本更新 文章
                this.$GetArticleData({locationId:2}).then(() => {
                    this.updateData = this.$store.state.articleData;
                });


                //产品优势

                 this.$GetCatalogueData({catalogueId:this.advantageUid})
                        .then(() => {
                           // this.advantageData = this.$store.state.catalogueData;
                            this.advantageData=this.$store.state.catalogueData.articles.list;
                            this.advantageData.map((item,i)=>{
                                this.$GetArticleData({ articleId: item.articleId}).then(() => {
                                    this.$set(this.advantageList,i,this.$store.state.articleData);
                                });
                            });

                        });
            });


            //轮播图
            this.$GetSlideData().then(() => {
                const { pictures=[] } = this.$store.state.slideData
                this.slideData = pictures;
            })


        },
        beforeUpdate(){
            let h = 0;
            h =  $('.updateRight_ul ul').height();
            this.updateRightUlHeight = h ;
        },
        mounted(){
            this.$GetStatistic();
        },
        methods:{
            sub(){
                const payload ={
                    name:this.name,
                    message:this.message,
                    email:this.email,
                    phone:this.phone,
                    type:Number(this.radioValue),

                }

                this.$PostAddMessage({...payload}).then(() => {
                    // console.log(999,this.$store.state)

                    // const addMessage = this.$store.state.addMessage;
                    // alert( this.$store.state.addMessageTotal.msg);
                    alert('提交成功，我们会尽快联系您。');

                    this.name='';
                    this.message='';
                    this.email='';
                    this.phone='';

                })

            },
            knowsub(){
                const payload ={
                    name:this.knowname,
                    message:this.knowmes,
                    email:this.knowemail,
                    phone:this.knowphone,
                    position:this.knowposition,
                    type:3,
                }

                this.$PostAddMessage({...payload}).then(() => {
                    // console.log(999,this.$store.state.addMessage)

                    // const addMessage = this.$store.state.addMessage;
                    // alert( this.$store.state.addMessageTotal.msg);
                    alert('提交成功，我们会尽快联系您。');

                      this.knowname='';
                      this.knowphone='';
                      this.knowemail='';
                      this.knowposition='';
                      this.knowmes='';

                })
            },
            enter(index){
             $('.btnDetailStyle').eq(index).addClass('btnhover');

                $('.btnDetailStyle').eq(index).css({
                    backgroundColor:"#5182E4",
                    color:"#fff"
                })
            },
            leave(index){
                // console.log(index);
                $('.btnDetailStyle').eq(index).css({
                    backgroundColor:"#fff",
                    color:"#5182E4"
                })
            }

        },
        filters:{
            //标签过滤
            htmlfilter(val){
                if(val){
                    return val.replace(/<[^>]*>/g,'');
                }

            },
        },
        components:{
            DeepModal,
        }
    }




</script>

<style scoped>

     /*.btnhover{*/
        /*color:red !important;*/
     /*}*/

</style>